import { css } from 'lit';
export const MaterialDesignCSS = css `
.mdi{
    font-family: "Material Design Icons";
    font-size: x-large;
    font-weight: var(--mdi-style, 900);
    font-style: normal;
}
.mdi-cash::before{
    content: '\u{f0114}';
}
.mdi-file-document-outline::before{
    content: '\u{f09ee}';
}
.mdi-car::before{
    content: '\u{f010b}';
}
.mdi-rectangle-outline::before{
    content: '\u{f0e5f}';
}
.mdi-pier-crane::before{
    content: '\u{f0888}';
}
.mdi-database-search::before{
    content: '\u{f0866}';
}
.mdi-file-cabinet::before{
    content: '\u{f0ab6}';
}
.mdi-gate::before{
    content: '\u{f0299}';
}
.mdi-boom-gate::before{
    content: '\u{f0e86}';
}
.mdi-store::before{
    content: '\u{f04dc}';
}
.mdi-format-list-bulleted::before{
    content: '\u{f0279}';
}
.mdi-map-outline::before{
    content: '\u{f0982}';
}
.mdi-message-text-outline::before{
    content: '\u{f036a}';
}
.mdi-pier::before{
    content: '\u{f0887}';
}
.mdi-printer::before{
    content: '\u{f042a}';
}
.mdi-road::before{
    content: '\u{f0461}';
}
.mdi-transit-connection-variant::before{
    content: '\u{f0d3d}';
}
.mdi-magnify::before{
    content: '\u{f0349}';
}
.mdi-cog::before{
    content: '\u{f0493}';
}
.mdi-ferry::before{
    content: '\u{f0213}';
}
.mdi-railroad-light::before{
    content: '\u{f0f1e}';
}
.mdi-table-large::before{
    content: '\u{f04f1}';
}
.mdi-crosshairs-gps::before{
    content: '\u{f01a4}';
}
.mdi-fence::before{
    content: '\u{f179a}';
}
.mdi-train::before{
    content: '\u{f052c}';
}
.mdi-train-car-container::before{
    content: '\u{f1b34}';
}
.mdi-truck::before{
    content: '\u{f053d}';
}
.mdi-radio-handheld::before{
    content: '\u{f043a}';
}
.mdi-warehouse::before{
    content: '\u{f0f81}';
}
.mdi-shower-head::before{
    content: '\u{f09a1}';
}
.mdi-scale::before{
    content: '\u{f0472}';
}
.mdi-wrench::before{
    content: '\u{f05b7}';
}
.mdi-keyboard-backspace::before{
    content: '\u{f030d}';
}
.mdi-circle::before{
    content: '\u{f0765}';
}
.mdi-circle-medium::before{
    content: '\u{f09de}';
}
.mdi-circle-small::before{
    content: '\u{f09df}';
}
.mdi-chevron-down::before{
    content: '\u{F0140}';
}
.mdi-chevron-up::before{
    content: '\u{F0143}';
}

`;
//# sourceMappingURL=MaterialDesignCSS.js.map